import AntdTooltip from 'antd/lib/tooltip';
import React       from 'react';
import useDidMount from '@widesk-core/hooks/useDidMount';

type TooltipRef = { close: () => void; };

const tooltipRefs: React.MutableRefObject<TooltipRef | undefined>[] = [];

export type TooltipPlacement = 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop'
	| 'leftBottom' | 'rightTop' | 'rightBottom';

export type TooltipProps = {
	color?: React.CSSProperties['color'];
	children: React.ReactNode;
	title: React.ReactNode;
	placement?: TooltipPlacement;
	zIndex?: number;
}

const Tooltip = (props: TooltipProps) => {
	const [open, setOpen] = React.useState(false);

	const ref = React.useRef<TooltipRef>();

	React.useImperativeHandle(ref, () => ({ close: () => setOpen(false) }));

	useDidMount(() => {
		tooltipRefs.push(ref);
		return () => tooltipRefs.splice(tooltipRefs.indexOf(ref), 1);
	});

	return (
		<AntdTooltip
			color={props.color}
			open={open}
			destroyOnHidden
			title={props.title}
			placement={props.placement}
			getPopupContainer={() => document.getElementById('root')!} // Permet aux dropdowns du wysiwyg de s'afficher
			onOpenChange={v => setOpen(v)}
			zIndex={props.zIndex}
		>
			{props.children}
		</AntdTooltip>
	);
};

Tooltip.closeAll = () => tooltipRefs.forEach(ref => ref.current?.close());

export default Tooltip;
